module.exports = __webpack_public_path__ + "img/sms.svg";